import React, { useState } from 'react';

const Counter = () => {
  const [count, setCount] = useState(1);

  const handleCount = (operasi) => {
    if (operasi === '-') {
      return count - 1 === 0 ? setCount(1) : setCount(count - 1);
    } else if (operasi === '+') {
      return setCount(count + 1);
    }
    return false;
  };

  return (
    <div className="flex gap-5 text-2xl">
      <p>Quantity</p>
      <div className="flex">
        <button className="w-8 flex justify-center bg-[#8a4af3] rounded-l-lg text-white cursor-pointer" onClick={() => handleCount('-')}>
          -
        </button>
        <div className="w-8 flex justify-center border-[1px] border-[#8a4af3]">{count}</div>
        <button className="w-8 flex justify-center bg-[#8a4af3] rounded-r-lg text-white cursor-pointer" onClick={() => handleCount('+')}>
          +
        </button>
      </div>
    </div>
  );
};

export default Counter;
